import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckmarkSquare = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M190 519L410 739L808 341L752 286L409 629L245 464ZM20 894V106C20 52 52 20 106 20H894C948 20 980 52 980 106V894C980 948 948 980 894 980H106C50 980 20 948 20 894ZM98 908H902V92H98Z" })
});
export default SvgCheckmarkSquare;
